import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import MainPage from './pages/mainpage';
import Purchase from './pages/purchase';
import About from './pages/about';
import Marketplace from './pages/marketplace';
import { useState } from 'react';


function App() {
  const [principal, setPrincipal] = useState(undefined);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage principal={principal} setPrincipal={setPrincipal} ></MainPage>}></Route>
        <Route path='/purchase' element={<Purchase principal={principal} setPrincipal={setPrincipal}></Purchase>}></Route>
        <Route path='/about' element={<About principal={principal} setPrincipal={setPrincipal}></About>}></Route>
        <Route path="/marketplace" element={<Marketplace principal={principal} setPrincipal={setPrincipal}></Marketplace>}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
